<!-- =========================================================================================
  File Name: appupdate.vue
  Description: Setting appupdate
========================================================================================== -->

<template>
  <div id="setting-appupdate">

    <vx-card title="APP更新">
		<div slot="actions">
		  <vs-button size="small" color="success" type="filled" @click="modify">添加新app</vs-button>
		</div>
      <vs-table stripe :data="list">
        <template slot="thead">
          <vs-th width="150">ID</vs-th>
          <vs-th width="400">标题</vs-th>
          <vs-th>版本号</vs-th>
          <vs-th>创建时间</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
            <vs-td :data="item.title">{{item.title}}</vs-td>
            <vs-td :data="item.version">{{item.version}}</vs-td>
            <vs-td :data="item.endDate">{{item.time}}</vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="dele" :data-index="index">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" title="添加APP更新" @confirm="submit">
      <div class="p-4">
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.title" label-placeholder="更新标题" />
        </div>
		<div class="mb-4">
		  <vs-input class="w-full" v-model="modifyItem.version" label-placeholder="版本号" />
		</div>
		<div class="mb-4">
		  <vs-input class="w-full" v-model="modifyItem.platform" label-placeholder="系统版本(Android/Ios)" />
		</div>
		
		<div class="mb-4">
		  <vs-input class="w-full" v-model="modifyItem.type" label-placeholder="更新方式(all/wget)" />
		</div>
		
		<div class="mb-4">
		  <vs-input class="w-full" v-model="modifyItem.contents" label-placeholder="更新说明" />
		</div>
		
		<div class="mb-4">
		  <vs-input class="w-full" v-model="modifyItem.url" label-placeholder="APP下载链接" />
		</div>

        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.is_mandatory" label="是否静默更新">
            <vs-select-item value="1" text="是" />
            <vs-select-item value="0" text="否" />
          </vs-select>
        </div>
 



      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'
import modifySiderBar from '../../layouts/components/modifySiderBar.vue'


export default {
  data() {
    return {
      list: [],
      modifyIndex: 0,
      modifyItem: {
		  id:0,
		  version:'',
		  platform:'',
		  url:'',
		  store_list:'',
		  contents:'',
		  title:'',
		  is_mandatory:0,
		  type:'all',
		  authKey:''
	  },
      flatPickrConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:s',
        locale: flatPickrZh
      },
      groupList: []
    }
  },
  components: {
    modifySiderBar,

  },
  methods: {
	  uploadToBase64 (e) {
	    const file = e.target.files[0]
	    
	    const reader = new FileReader()
	    reader.readAsDataURL(e.target.files[0])
	    reader.onload = (e) => {
	      this.modifyItem.url = e.target.result
	    }
	  },
	  reUpload () {
	    this.modifyItem.url = ''
	  },
    modify (e) {
      this.modifyItem = {
		  id:0,
		  version:'',
		  platform:'Android',
		  url:'',
		  store_list:'',
		  authKey: '',
		  contents:'',
		  title:'',
		  is_mandatory:0,
		  type:'all'
	  }
      this.$refs.modifySiderBar.open()
    },
	dele(e){
		this.modifyIndex = e.currentTarget.dataset.index
		this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
		
		const postdata = {}
		postdata.authKey = localStorage.getItem('authKey')
		postdata.id = this.modifyItem.id
		this.$vs.dialog({
		  type: 'confirm',
		  color: 'danger',
		  title: '确认',
		  text: '确认删除吗?',
		  acceptText: '确认',
		  cancelText: '取消',
		  accept: () => {
		    this.$utils.post('setting-appdeleDo', postdata).then(res => {
		      this.$vs.dialog({
		        title: '提示',
		        text: res,
		        acceptText: '确认'
		      })
		      this.getList();
		      this.$forceUpdate()
		    })
		  }
		})

		
	},
	getList(){
		this.$utils.post('setting-appupdateList', { authKey: localStorage.getItem('authKey') }).then(res => {
		  this.list = res
		})
	},
    submit () {
      const postdata = this.modifyItem
      postdata.authKey = localStorage.getItem('authKey')
	console.log(postdata);
      this.$utils.post('setting-appupdateDo', postdata).then(res => {
		  this.getList();
		  this.$refs.modifySiderBar.close()
		  this.$forceUpdate()
		  
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认',
		  accept: () => {
			  
		  }
        })
		
      })
    }
  },
  mounted () {
    // 读取设置
    this.getList()

  }
}
</script>
